import {
    GET_CMS_BANNER,
    GET_CMS_BANNER_ERROR
} from "./types";
import CMSService from "../../services/cms.service";

export function getBanner() {
    return function (dispatch) {
        try {           
            return CMSService.reqBanner()
                .then((data) => {                                       
                    dispatch(
                        {
                            type: GET_CMS_BANNER,
                            payload: data
                        })
                });
        }
        catch (error) {
            return (dispatch) => {
                dispatch({
                    type: GET_CMS_BANNER_ERROR,
                });
            }
        }
    };
}